'use client';

import { SelectField } from '@petsmart-ui/sparky';
import type { ChangeEventHandler, FocusEventHandler } from 'react';

import type { QuantityOption } from '../lib';
import './quantity-picker.scss';

type QuantityPickerProps = Readonly<{
    items: QuantityOption[];
    value: string;
    name: string;
    disabled?: boolean;
    onChange: ChangeEventHandler<HTMLSelectElement>;
    onBlur?: FocusEventHandler<HTMLSelectElement>;
    testId?: string;
}>;

export function QuantityPicker({
    items,
    value,
    name,
    disabled = false,
    onChange,
    onBlur,
    testId = 'quantity-selector',
}: QuantityPickerProps) {
    return (
        <SelectField
            label="Qty"
            items={items}
            disabled={disabled}
            value={value}
            className="qty-selector"
            data-testid={testId}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
}
